import { sourceNameMapping } from '@components/common/sourceIcons'
import { ActivityActionItem } from '@/types/activity'

const getRelatedTimeEntry = (item: ActivityActionItem) =>
  item.relateTimeEntry ||
  item.timeEntry ||
  item.time_entry ||
  item.timeentry_data

export const getRelatedTimeEntryId = (item: ActivityActionItem) =>
  getRelatedTimeEntry(item)?.id ||
  item.timeentry ||
  item.timeentry_id ||
  item.time_entry_id

export const getAssociatedActivitySlots = (item: ActivityActionItem) => {
  const entry = getRelatedTimeEntry(item)
  if (entry?.slots?.length) return entry.slots
  if (entry?.slot_ids?.length) return entry.slot_ids.map(id => ({ id }))
  return [item]
}

export const getRestoreSourceName = (item: ActivityActionItem) => {
  const relatedTimeEntry = getRelatedTimeEntry(item)
  const sourceKey =
    relatedTimeEntry?.apps?.find(Boolean) ||
    relatedTimeEntry?.non_svc_source ||
    item.apps?.find(Boolean) ||
    item.non_svc_source ||
    'source'
  return sourceNameMapping[sourceKey] || sourceKey
}
